//  mutaciones son sincronas y hacen modificaciones del state

// Trae Investigadores
export const setAllInvestigators = (state, investigators) => {
  if (investigators.length !== 0) {
    state.investigators = [...investigators];
    state.isLoading = false;
  }
  state.isLoading = false;
};

//Inserta Investigadores
export const insertInvestigators = (state, investigators) => {
  if (investigators.length !== 0) {
    state.investigators = [investigators, ...state.investigators];
    state.isLoading = false;
  }
  state.isLoading = false;
};

//Edita Investigadores
export const updateInvestigators = (state, investigator) => {
  if (investigator.length !== 0) {
    const { idInvestigador } = investigator;
    state.investigators.forEach((e) => {
      const { id } = e;
      if (idInvestigador === id) {
        e = investigator;
        state.isLoading = false;
        return;
      }
    });
  }
  state.isLoading = false;
};

//Valida RFC de Investigadores
export const rfcInvestigators = (state, rfc) => {
  state.rfc = rfc;
  state.isLoading = false;
};

//Elimina Investigadores
export const deleteInvestigators = (state, investigator) => {
  if (investigator.length !== 0) {
    const { id } = investigator;
    for (let i = 0; i < state.investigators.length; i++) {
      if (state.investigators[i].idInvestigador === id) {
        state.investigators.splice(i, 1);
        state.isLoading = false;
        return;
      }
    }
  }
  state.isLoading = false;
};

// Semestres
export const traeSemestres = (state, semesters) => {
  if (semesters.length !== 0) {
    state.semesters = [...semesters];
    state.isLoading = false;
  }
  state.isLoading = false;
};

export const setSemestres = (state, newSemestre) => {
  const {nuevoSemestre} = newSemestre;
  if (nuevoSemestre.length !== 0) {
    if (newSemestre.numSemestres === 1) {

      state.semesters = [nuevoSemestre];
      state.isLoading = false;
    } else {

      state.semesters = [nuevoSemestre, ...state.semesters];
      state.isLoading = false;
    }
  }
  state.isLoading = false;
};

export const updateSemestres = (state, semesters) => {
  if (semesters.length !== 0) {
    // state.semesters[0] = semesters.slice();
    state.semesters.splice(0, 1, semesters);
    state.isLoading = false;
  }
  state.isLoading = false;
};

// Estancias

export const listEstancias = (state, estancias) => {
  state.estancias = [...estancias];
  state.isLoading = false;
};

export const deleteEstancia = (state, estancia) => {
  if (estancia.length !== 0) {
    const { idEstancia } = estancia;
    for (let i = 0; i < state.estancias.length; i++) {
      if (state.estancias[i].idEstancia === idEstancia) {
        // state.idEstancia.splice(i,1);
        state.estancias[i].estatus = "B";
        state;
        state.isLoading = false;
        return;
      }
    }
  }
  state.isLoading = false;
};

// Alumnos
export const setAlumnosLicenciatura = (state, alumnosLic) => {
  if (alumnosLic.length !== 0) {
    state.alumnosLicenciatura = [...alumnosLic];
    state.isLoading = false;
  }
  state.isLoading = false;
};

export const setAlumnosBachillerato = (state, alumnosBachi) => {
  if (alumnosBachi.length !== 0) {
    state.alumnosBachillerato = [...alumnosBachi];
    state.isLoading = false;
  }
  state.isLoading = false;
};

export const insertAlumno = (state, alumnos) => {
  if (alumnos.length !== 0) {
    state.alumnosLicenciatura = [alumnos, ...state.alumnosLicenciatura];
    state.isLoading = false;
  }
};

export const insertAlumnoBachillerato = (state, alumnos) => {
  if (alumnos.length !== 0) {
    state.alumnosBachillerato = [alumnos, ...state.alumnosBachillerato];
    state.isLoading = false;
  }
};

export const deleteAlumnos = (state, index) => {
  state.alumnosLicenciatura.splice(index, 1);
  state.isLoading = false;
  return;
};
